import Vue from "vue";

const getDefaultState = () => {
	return {
		// handleError
		apierrors: {},
	};
};

// initial state
const state = getDefaultState();

const getters = {
	// handleError
	getApiErrors: (state) => {
		return state.apierrors;
	},
};
const actions = {
	handleResponseMessage({ commit, dispatch }, response) {
		let color = "success";
		let message = null;
		let title = "Attenzione!";
		let type = null;
		let duration = 3000;
		let reload = false;

		if (response.code) {
			switch (response.code) {
				case 1:
					color = "warning";
					type = "snackbar";
					duration = 5000;
					break;
				case 2:
					color = "error";
					type = "dialog";
					break;
				case 3:
					color = "success";
					type = "dialog";
					break;
				default:
					break;
			}
		}
		if (response.message) {
			message = response.message;
			if (!type) {
				type = "snackbar";
			}
		}
		if (response.errormessage) {
			message = response.errormessage;
			duration = 5000;
			color = "error";
			if (!type) {
				type = "snackbar";
			}
		}
		if (response.errors) {
			commit("handleError", response.errors);
		}
		if (response.title) {
			title = response.title;
		}
		if (response.reload) {
			reload = true;
		}
		switch (type) {
			case "dialog":
				commit("showDialog", {
					type: color == "error" ? "alert" : "advice",
					title: title,
					message: message,
					okCb: () => {
						if (reload) {
							commit("resetActiveModules");
							dispatch("fetchTenantInfo");
							dispatch("fetchUserSetting");
							dispatch("fetchTenant");
							dispatch("fetchAutocompleteUser");
							dispatch("fetchAutocompleteRoom");
							dispatch("fetchActiveModules");
							dispatch("fetchAutocompletePricelist");
							dispatch("fetchAutocompletePatient");
							dispatch("fetchCounters");
						}
					},
				});
				break;
			case "snackbar":
				commit("showSnackbar", {
					message: message,
					duration: duration,
					color: color,
				});
				break;
			default:
				break;
		}
	},
	handleError({ commit }, errors) {
		if (errors.response.data) {
			if (errors.response.data.errors) {
				commit("handleError", errors.response.data.errors);
				return;
			}
			if (errors.response.data.errormessage) {
				commit("showSnackbar", {
					message: errors.response.data.errormessage,
					color: "error",
					duration: 5000,
				});
			} else {
				if (errors.response.status) {
					commit("showSnackbar", {
						message: errors.response.data.message,
						color: "error",
						duration: 5000,
					});
				}
			}
		} else {
			if (errors.status) {
				commit("showSnackbar", {
					message: errors.data.message,
					color: "error",
					duration: 5000,
				});
			}
		}
	},
};
const mutations = {
	resetState_errors(state) {
		Object.assign(state, getDefaultState());
	},
	// handleError
	handleError(state, apierrors) {
		Vue.set(state, "apierrors", apierrors);
	},
};
export default {
	state,
	getters,
	mutations,
	actions,
};
